// Getters
export const IPR_IS_ERROR = "iprange/stateIprIsError";
export const IPR_IS_LOADING = "iprange/stateIprIsLoading";
export const IPR_GET_DATA = "iprange/stateIprData";
export const IPR_GET_FILTER = "iprange/stateIprFilter";

//Mutations
// export const IPR_MUTATION_FILTER_EMAIL = 'iprange/stateIprFilterEmail';
// export const IPR_MUTATION_CLEAR_FILTER = 'iprange/stateIprFilterClear';

// Actions
export const IPR_ACTION_FILTER = "iprange/stateIprSearchByFilter";
export const IPR_ACTION_CLEAR_FILTER = "iprange/stateIprFilterClear";



// WEBPACK FOOTER //
// ./src/store/types_iprange.js